import { gql } from '@apollo/client';

export const GEAR_TYPES = gql`
  query getAvailableGearTypes($inputGearType: String!) {
    getAvailableGearTypes(inputGearType: $inputGearType)
  }
`;
